import React from 'react';
import { X } from 'lucide-react';

const Modal = ({ isOpen, onClose, title, children, maxWidth = 'max-w-lg' }) => {
  if (!isOpen) return null;

  // Convert maxWidth classes to actual CSS widths for better compatibility
  const getWidthStyle = (maxWidth) => {
    switch (maxWidth) {
      case 'max-w-5xl':
        return { maxWidth: '64rem', width: '95%' }; // 1024px
      case 'max-w-4xl':
        return { maxWidth: '56rem', width: '90%' }; // 896px  
      case 'max-w-3xl':
        return { maxWidth: '48rem', width: '85%' }; // 768px
      case 'max-w-2xl':
        return { maxWidth: '42rem', width: '80%' }; // 672px
      case 'max-w-xl':
        return { maxWidth: '36rem', width: '75%' }; // 576px
      case 'max-w-lg':
      default:
        return { maxWidth: '32rem', width: '70%' }; // 512px
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    }}>
      <div
        style={{
          backgroundColor: 'var(--color-bg-surface)',
          borderRadius: 'var(--radius-md)',
          padding: '24px',
          ...getWidthStyle(maxWidth),
          maxHeight: '90vh',
          overflowY: 'auto',
          boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
        }}
      >
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginBottom: '20px'
        }}>
          <h3 style={{
            fontSize: '18px',
            fontWeight: '600',
            color: 'var(--color-text-primary)',
            margin: 0
          }}>
            {title}
          </h3>
          {/* Hover lives in .ui-modal-close (index.css). The old onMouseEnter set
              e.target.style, which resolved to the inner <svg> when the pointer
              was over the icon rather than the button's padding. */}
          <button
            className="ui-modal-close"
            onClick={onClose}
          >
            <X size={20} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default Modal;